// React
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// Lib
import i18next from 'i18next';

// Components
import Dialog from '../../../dialog';
import { TextArea } from '../../../../../msreact-kit/packages/html-components';
import DownloadDoument from '../../../../../msreact-kit/html-components/download-document';

// Css
import '../index.scss';
import Loader from '../../../../../components/Shared/Utils/Loader';

const AddComment = ({
  handleCloseCommentBox,
  header,
  subHeader,
  onInput,
  handleSubmitComment,
  handleDownloadInvoice,
  currentCommentLength,
  error,
  value,
  isReseller
}) => {
  const commentData = {
    attributeId: null,
    name: 'addComment',
    displayName: subHeader,
    description: '',
    xpath: '',
    jsonType: null,
    handleChange: onInput,
    attributeType: 'TEXT AREA',
    placeHolder: i18next.t(
      'ORDER_MANAGEMENT.ORDER_SUMMARY_POPUPS.ADD_TRANSIT_POPUP.WRITE_HERE1'
    ),
    displayOrder: 4,
    isVisibleForBuyer: null,
    isElementRequired: true,
    stateChangeOnEdit: false,
    isEncryptable: false,
    validation: {
      rule: {
        required: {
          isRequired: true,
          errorCode: 'MS102',
          errorMessage: ''
        },
        length: {
          min: 1,
          max: 1000,
          errorCode: 'MS105',
          errorMessage: ''
        }
      }
    },
    nonEditableAttributeValidation: null,
    optionType: null,
    options: null,
    attributes: null,
    sections: [],
    value: value
  };

  const { content, isLoading } = useSelector((state) => {
    return {
      content: state.ContentReducer.content,
      isLoading: state.OrderSummaryReducer.isLoading
    };
  });
  const isReadyToShip =
    header ===
    i18next.t('ORDER_MANAGEMENT.DYNAMIC_POPUP.WRITE_REMARK_TO_READY_TO_SHIP');
  const readyToShipContent =
    content?.components?.user_management?.order_fulfillment?.ready_to_ship;

  return (
    <div className='add-comment'>
      <div className='add-comment__container'>
        <Dialog
          header={header}
          isPrimary={false}
          secondLabel={i18next.t('DYNAMIC_FORM.SHARED.BUTTON.SUBMIT')}
          isTertiary={false}
          isTitle={false}
          isDivider={false}
          onCloseDialog={handleCloseCommentBox}
          handleSubmitClick={handleSubmitComment}
          commentBoxLength={currentCommentLength}
        >
          {isReseller && isReadyToShip && (
            <>
              {isLoading && <Loader />}
              <DownloadDoument title={readyToShipContent?.download_invoice} handleDownloadInvoice={handleDownloadInvoice} />
            </>
          )}
          <TextArea error={error} {...commentData}></TextArea>
          {isReseller && isReadyToShip && (
            <div className='info-text'>
              <i className='a-icon boschicon-bosch-ic-alert-info info-style-icon'></i>
              <p>
                {readyToShipContent?.text_2}
              </p>
            </div>
          )}
        </Dialog>
      </div>
    </div>
  );
};

AddComment.propTypes = {
  handleCloseCommentBox: PropTypes.func,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  onInput: PropTypes.string,
  handleSubmitComment: PropTypes.func,
  currentCommentLength: PropTypes.number,
  value: PropTypes.string
};

export default AddComment;
